import React from "react";
import CommunityEditPage from "../community/components/CommunityEditPage";
import { ASK_FOR_HELP } from "../community/constants";
import { useRequireSectionVisible } from "../../client/hooks/useRequireSectionVisible";

export default function EditAskForHelpPage() {
  useRequireSectionVisible("showAskForHelp");
  return <CommunityEditPage section={ASK_FOR_HELP} />;
}
